import React from 'react';

export const LogoCircle = () => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="logo-circle"
      style={{ width: '70px', height: '70px' }}
    >
      <rect x="0.5" y="0.5" width="69" height="69" rx="34.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="69"
        height="69"
        rx="34.5"
        stroke="url(#paint0_linear_397_422)"
      />
      <path
        d="M31.5 14.5C33.5 14.0999 37.5004 14 40.5 15C35.8333 15.5 23.1447 22.397 25.5 37C28 52.5 41.5 53.5 50 49C47 52 43 54.5 36.499 53.5C26.4992 51.4999 23.5 43.5 22 38C20.7727 33.4999 22.5 23.5 28 19C24 21 19.8173 25.3206 18.5 32.5C16.39 44 19.5 46.5 22 50.5C20 49 14.5 45.5 14.5 33.5C14.5 24 24.4998 15.5 31.5 14.5Z"
        fill="url(#paint1_linear_397_422)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35 8C49.9117 8 62 20.0883 62 35C62 49.9117 49.9117 62 35 62C20.0883 62 8 49.9117 8 35C8 20.0883 20.0883 8 35 8ZM35 12.459C22.5511 12.459 12.459 22.5511 12.459 35C12.459 47.4489 22.5511 57.541 35 57.541C47.4489 57.541 57.541 47.4489 57.541 35C57.541 22.5511 47.4489 12.459 35 12.459Z"
        fill="url(#paint2_linear_397_422)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_397_422"
          x1="74.5"
          y1="79.5"
          x2="17"
          y2="-3.85302e-08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#909BFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_397_422"
          x1="35"
          y1="8"
          x2="35"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B5CFF" />
          <stop offset="1" stopColor="#8CD7FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_397_422"
          x1="35"
          y1="8"
          x2="35"
          y2="62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B5CFF" />
          <stop offset="1" stopColor="#8CD7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoCircle; 